import { render, staticRenderFns } from "./ADREvents.vue?vue&type=template&id=bcefcce8&"
import script from "./ADREvents.vue?vue&type=script&lang=ts&"
export * from "./ADREvents.vue?vue&type=script&lang=ts&"
import style0 from "./ADREvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports